// Homeowner intent ("urgency") display labels and badge colors.
// Maps raw database values to homeowner-facing copy.
//
// Legacy values (today / this_week / this_month) are still stored on open
// and historical requests, so they must keep rendering. Do not remove them.

export const urgencyLabels: { [key: string]: string } = {
  // Current vocabulary
  ready_now: 'Ready to hire now',
  within_30_days: 'Within 30 days',
  comparing: 'Comparing options',
  researching: 'Researching only',
  // Legacy values still present in the database
  today: 'Need it today',
  this_week: 'This week',
  this_month: 'This month',
};

export const urgencyColors: { [key: string]: string } = {
  // Current vocabulary
  ready_now: '#e74c3c',
  within_30_days: '#3498db',
  comparing: '#16a085',
  researching: '#95a5a6',
  // Legacy values still present in the database
  today: '#e74c3c',
  this_week: '#f39c12',
  this_month: '#3498db',
};

export function getUrgencyLabel(raw?: string | null): string {
  if (!raw) return 'Flexible';
  return urgencyLabels[raw] || raw.replace(/_/g, ' ');
}

export function getUrgencyColor(raw?: string | null): string {
  if (!raw) return '#95a5a6';
  return urgencyColors[raw] || '#95a5a6';
}
